import interactions from '@gov.wa.lni/application.child-labor-complaint/source/interactions';
import components from '@gov.wa.lni/application.child-labor-complaint/source/components';

import ApplicationMain from '@gov.wa.lni/application.child-labor-complaint/source/application-main.vue';
import HomePage from '@gov.wa.lni/application.child-labor-complaint/source/pages/home.page.vue';
import ConfirmationPage from '@gov.wa.lni/application.child-labor-complaint/source/pages/confirmation.page.vue';

import store from '@gov.wa.lni/application.child-labor-complaint/source/store.js';

const options = {
    addAccessibleRouting : true,
    components           : { ApplicationMain },
    applicationComponents: [...components],
    applicationActions   : interactions,
};

const routes = [
    {
        path     : '/',
        name     : 'HomePage',
        component: HomePage,
        meta     : { title: 'Child Labor Complaint' },
    },
    {
        path     : '/confirmation',
        name     : 'ConfirmationPage',
        component: ConfirmationPage,
        meta     : { title: 'Confirmation' },
    },
];
options.routing = {
    routes,
    navigationGuards: {
        beforeEach: (store, to, from, next) => {
            if (to.path === '/') {
                next();
                return;
            } else if (to.path === '/confirmation' && store.state.appState?.complaintNumber) {
                next();
                return;
            }

            next('/');
        },
    },
};

window.lni.oneLniCorePlugin.initialize(
    options,
    configuration => {
        window.lni.Vue.use(window.lni.oneLniCorePlugin);
        const application = new window.lni.Vue(configuration);
        window.lni.oneLniCorePlugin.setApplication(application);
        application.$store.registerModule('appState', store);
    },
);